// export interface FileName {
// 	id: string;
// 	name: string;
// }

export enum FileAction {
	Add = 'add',
	Remove = 'remove',
}

export type FileUploadType = {
	id: string;
	name: string;
	type?: string;
	base64File?: string;
	inputType?: string;
};

export interface TemporaryFile {
	id: string;
	error: number;
	file: any;
	base64File: string;
}
